import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.NetSuiteVendorCreationPopup', {
    popupTitle: 'New Vendor',
    createButton: 'Create',
    mandatoryError: 'Please fill in all mandatory fields.',
    duplicatedSubsidiary: 'Subsidiary in table should be unique.',
});
